import { getResizedImageUrl } from '../../../../../common/utils/get-resized-image-url';
import { getCookie } from '../../../../../common/utils/cookie';
const SHARE_IMAGE_WIDTH = 480;
const SHARE_IMAGE_HEIGHT = 360;
export const buildImageUrl = url => getResizedImageUrl({
  url,
  width: SHARE_IMAGE_WIDTH,
  height: SHARE_IMAGE_HEIGHT
});
export const getBsi = () => {
  try {
    if (window.commonConfig) {
      return window.commonConfig.bsi;
    }
    if (window.Wix) {
      return Wix.Utils.commonConfig.get('bsi');
    }
    return getCookie('bSession');
  } catch {
    return undefined;
  }
};
//# sourceMappingURL=index.js.map